import { h, JSX, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import cx from 'classnames'
import { diagonal, profil, skilleProfil } from '@nrk/valg-profilelement'

import styles from './index.css'

function width2number(width) {
  switch (width) {
    case 320:
      return 1
    case 360:
      return 2
    case 480:
      return 3
    case 540:
      return 4
    case 640:
      return 5
    case 720:
      return 6
    case 750:
      return 7
    case 768:
      return 8
    case 800:
      return 9
    case 1024:
      return 10
    case 1080:
      return 11
    case 1125:
      return 12
    case 1280:
      return 13
    case 1440:
      return 14
    case 1920:
      return 15
    case 2560:
      return 16
    case 3840:
      return 17
    case 4096:
      return 18
    default:
      return 1024
  }
}

const WIDTHS = [
  320,
  360,
  480,
  540,
  640,
  720,
  750,
  768,
  800,
  1024,
  1080,
  1125,
  1280,
  1440,
  1920,
  2560,
  3840,
  4096
]

interface Props extends JSX.HTMLAttributes {
  id: string
  class: string
  inElement?: boolean
}

export function Profil({ id, class: clazz, inElement }: Props) {
  const cap = inElement ? 9 : WIDTHS.length
  const baseUrl = '/valg/2019/resultat/api/decoration/profil'

  return (
    <picture id={id} class={clazz}>
      <Fragment>
        {WIDTHS.slice(0, cap).map(w => (
          <Fragment>
            <source srcset={`${baseUrl}/${width2number(w)}`} media={`(max-width: ${w}px)`} />
          </Fragment>
        ))}
      </Fragment>
      <img src={`${baseUrl}/9`} alt="" />
    </picture>
  )
}

export function Skille() {
  const baseUrl = '/valg/2019/resultat/api/decoration/skille'

  return (
    <picture class={styles.skilleProfil}>
      <Fragment>
        {WIDTHS.slice(0, 9).map(w => (
          <Fragment>
            <source srcset={`${baseUrl}/${width2number(w)}`} media={`(max-width: ${w}px)`} />
          </Fragment>
        ))}
      </Fragment>
      <img src={`${baseUrl}/9`} alt="" />
    </picture>
  )
}

export function Diagonal({ class: clazz }) {
  const baseUrl = '/valg/2019/resultat/api/decoration/diagonal'
  return <img class={clazz} src={`${baseUrl}/1`} alt="" />
}
